// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2FuZi","pages":"styles_pages__1rekM"};